(() => {
    window.addEventListener('load', function() // just to run when the window is done loading
    {
        // initial declaration stack
        let swatchColors = document.querySelectorAll('.swatch--color');
        let swatchOptions = document.querySelectorAll('.swatch--option');
        let skuDisplay = document.querySelectorAll('.skuDisplay');
        let firstActiveSwatches = document.querySelectorAll('.swatch--active')

        function changeSku() { // swap out the sku from our hidden group of skus
            if (firstActiveSwatches.length > 1) {
                skuDisplay.forEach(display => display.classList.add('hidden'));
                let swatchColor = this.dataset.swatchOption.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                let thisSku = document.querySelectorAll(`.sku${swatchColor}`);
                thisSku.forEach(sku => sku.classList.remove('hidden'));
            }
        }

        if (swatchColors.length != 0 || swatchOptions.length != 0 && firstActiveSwatches.length > 1) { // if there are color swatch options or swatch options
            if(swatchColors.length > 0 && swatchOptions.length == 0) { // if we have color swatches but no size swatches
                swatchColors.forEach(swatch => {
                    let firstActiveSku = document.querySelector('.swatch--active');
                    let skuVariant = firstActiveSku.dataset.swatchOption.toUpperCase();
                    skuVariant = skuVariant.replace(/\//g, '')
                    let firstActive = document.querySelectorAll(`.sku${skuVariant}`);
                    swatch.addEventListener('click', changeSku);
                    firstActive.forEach(active => active.classList.remove('hidden'));
                });
            }
            else if (swatchOptions.length > 0 && swatchColors.length == 0 && firstActiveSwatches.length > 1) { // has sizes but no colors
                swatchOptions.forEach(option => {
                    let firstActiveSku = document.querySelector('.swatch--active');
                    let skuVariant = firstActiveSku.dataset.swatchOption.toUpperCase();
                    let firstActive = document.querySelectorAll(`.sku${skuVariant}`);
                    option.addEventListener('click', changeSku);
                    firstActive.forEach(active => active.classList.remove('hidden'));
                });
            }
        }

        function changeSkuFromMultipleSwatches() { // using both swatches, swap out the sku
            skuDisplay.forEach(display => display.classList.add('hidden'));
            let activeSwatches = document.querySelectorAll('.swatch--active');
            let optionArray = [];
            activeSwatches.forEach(swatch =>  {
                if (optionArray.includes(swatch.dataset.swatchOption)) {
                } else {
                    optionArray.push(swatch.dataset.swatchOption)
                }
            });
            let thisSku = document.querySelectorAll(`.sku${optionArray.join('').replace(/[^a-zA-Z0-9]/g, '').toUpperCase()}`);
            thisSku.forEach(sku => sku.classList.remove('hidden'));
        }

        if (firstActiveSwatches.length > 2) {
            let activeSwatches = document.querySelectorAll('.swatch--active');
            let variantSwatches = document.querySelectorAll('.variantSwatch');
            let optionArray = [];
            activeSwatches.forEach(swatch =>  {
                if (optionArray.includes(swatch.dataset.swatchOption)) {
                } else {
                    optionArray.push(swatch.dataset.swatchOption)
                }
            });
            let thisSku = document.querySelectorAll(`.sku${optionArray.join('').replace(/[^a-zA-Z0-9]/g, '').toUpperCase()}`);
            thisSku.forEach(sku => sku.classList.remove('hidden'));
            variantSwatches.forEach(swatch => swatch.addEventListener('click', changeSkuFromMultipleSwatches));
        }

        if (swatchColors.length == 0 && swatchOptions.length == 0) { // if there are no variants or swatches for the product, just show the sku.
            skuDisplay.forEach(display => display.classList.remove('hidden'));
        }
    })
})();